import React, { useEffect, useRef, useState } from 'react';
import { Table, Button, Card, Space, Modal, Input } from 'antd';
import { EditOutlined, PlusOutlined } from '@ant-design/icons';
import { RmCountPriceListService } from '@gtpl/shared-services/raw-material-procurement';
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, useHistory } from 'react-router-dom';
import ProductCountForm from './product-count-form';
import { ProductCountDto } from '@gtpl/shared-models/raw-material-procurement';
import { ColumnProps } from 'antd/lib/table';
import Highlighter from 'react-highlight-words';
import { SearchOutlined } from '@ant-design/icons';
export function ProductCountView() {
  const [data, setData] = useState<ProductCountDto[]>([]);
  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState<ProductCountDto | null>(null);
  const service = new RmCountPriceListService();
    const searchInput = useRef(null);
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState(''); 
  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await service.getAllProductCount();
      if (res.status) {
        setData(res.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleEdit = (record: ProductCountDto) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const getColumnSearchProps = (dataIndex: any,
    customFilterFn?: (value: string, record: any) => boolean) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => confirm()}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => confirm()}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button onClick={clearFilters} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    ),
    filterIcon: filtered => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: customFilterFn
      ? (value, record) => customFilterFn(value, record)
      : (value, record) =>
          record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : false,
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => searchInput?.current?.select(), 100);
      }
    },
    render: (text, record) => {
      const cellValue = typeof text === 'string' ? text : '';
      return searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={cellValue}
        />
      ) : (
        text
      );
    }
  });

  const columns : ColumnProps<any>[] = [
    {
      title: 'S.No',
      key: 'sNo',
      render: (text: string, record: any, index: number) => index + 1,
    },
    // {
    //   title: 'Product',
    //   dataIndex: 'productName',
    //   key: 'productName',
    //   sorter: (a, b) => a.productName.localeCompare(b.productName),
    //   sortDirections: ['descend', 'ascend'],
    //   ...getColumnSearchProps('productName'),
    // },
    {
      title: 'Count',
      dataIndex: 'count',
      key: 'count',
      sorter: (a, b) => a.count.localeCompare(b.count),
      sortDirections: ['descend', 'ascend'],
      ...getColumnSearchProps('count'),
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   render: (text: string, record: ProductCountDto) => (
    //     // <Space size="middle">
    //     //   <Button type="primary" icon={<EditOutlined />} onClick={() => handleEdit(record)} />
    //     // </Space>
    //     <></>
    //   ),
    // },
  ];

  return (
    <>
      <Card  title={<span style={{ color: 'white' }}>Product Counts</span>} style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }}
        extra={
          <Button type="primary"  onClick={() => { setSelectedRecord(null); setIsModalVisible(true); }}>
            Create
          </Button>
        }
      >
        <Table columns={columns} dataSource={data} rowKey="productCountId" loading={loading} />
      </Card>

      <Modal
        title={selectedRecord ? 'Edit Product Count' : 'Add Product Count'}
        visible={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        destroyOnClose
      >
        <ProductCountForm
          record={selectedRecord}
          onSuccess={() => {
            setIsModalVisible(false);
            fetchData();
          }}
          onCancel={() => setIsModalVisible(false)}
        />
      </Modal>
    </>
  );
}

export default ProductCountView;